import React from 'react';
import { MapPin } from 'lucide-react';

const ServiceArea = () => {
  return (
    <section id="service-area" className="py-16 bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-center md:text-left">
          <div className="flex items-center justify-center w-16 h-16 bg-teal-600 rounded-full">
            <MapPin className="w-8 h-8 text-white" />
          </div>
          <div>
            <h3 className="text-2xl md:text-3xl font-bold mb-2">
              Proudly Serving Columbus, Ohio
            </h3>
            <p className="text-slate-300 text-lg">
              and nearby communities
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceArea;
